import { ProfilSubmary } from "./ProfilSubmary"

export interface TexteModele {
    id: string;
    titre: string;
    auteurCreation?: ProfilSubmary;
    auteurModification?: ProfilSubmary;
    documentClass?: string | null;
    documentType?: string | null;
    documentFormat?: string | null;
    dateCreation?: Date;
    dateModification?: Date;
    text?: string;
    type?: TypeEnum;
}

export enum TypeEnum {
    Consultation = "consultation",
    Courrier = "courrier",
    Glossaire = "glossaire",
    Pensebete = "pensebete",
  }